import React, { useEffect, useState } from 'react';
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { mockEmployees } from '../../utils/mockData';
import { getMonthDays, getToday } from '../../utils/dateUtils';
export function BirthdayCalendarWidget() {
  const [currentDate, setCurrentDate] = useState(getToday());
  const [calendarDays, setCalendarDays] = useState<(Date | null)[]>([]);
  const [birthdayMap, setBirthdayMap] = useState<Record<number, number>>({});
  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const days = getMonthDays(year, month);
    setCalendarDays(days);
    const counts: Record<number, number> = {};
    mockEmployees.forEach(e => {
      if (!e.isActive) return;
      const [bMonth, bDay] = e.birthday.split('-').map(Number);
      if (bMonth === month + 1) {
        counts[bDay] = (counts[bDay] || 0) + 1;
      }
    });
    setBirthdayMap(counts);
  }, [currentDate]);
  const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  const monthName = currentDate.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });
  const today = getToday();
  return <Card title="Birthday Calendar" icon={<CalendarIcon className="h-4 w-4" data-id="element-920" />} action={<div className="flex items-center gap-1" data-id="element-921">
          <button onClick={prevMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-922">
            <ChevronLeft className="h-3.5 w-3.5 text-gray-600" data-id="element-923" />
          </button>
          <span className="text-[11px] font-medium w-20 text-center text-gray-700" data-id="element-924">
            {monthName}
          </span>
          <button onClick={nextMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-925">
            <ChevronRight className="h-3.5 w-3.5 text-gray-600" data-id="element-926" />
          </button>
        </div>} data-id="element-919">
      <div className="space-y-1.5" data-id="element-927">
        <div className="grid grid-cols-7 gap-0.5 text-center" data-id="element-928">
          {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => <div key={`${d}-${i}`} className="text-[9px] font-medium text-gray-400 py-0.5" data-id="element-929">
              {d}
            </div>)}
        </div>
        <div className="grid grid-cols-7 gap-0.5" data-id="element-930">
          {calendarDays.map((date, idx) => {
          if (!date) return <div key={`empty-${idx}`} className="h-6" data-id="element-931" />;
          const dayNum = date.getDate();
          const count = birthdayMap[dayNum];
          const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
          return <div key={idx} className={`h-6 flex flex-col items-center justify-center rounded text-[10px] relative ${isToday ? 'bg-gradient-to-br from-orange-50 to-orange-100 text-orange-700 font-bold border border-orange-200 shadow-sm' : 'hover:bg-gray-50 text-gray-700'}`} data-id="element-932">
                <span data-id="element-933">{dayNum}</span>
                {count > 0 && <div className="absolute bottom-0.5 h-0.5 w-0.5 rounded-full bg-pink-500" title={`${count} birthday(s)`} data-id="element-934" />}
              </div>;
        })}
        </div>
      </div>
    </Card>;
}